export default __webpack_public_path__ + "01cad25c32243047cb86112a81d32927.png";